import { FormattedMessage } from 'react-intl';

export default [
    {
        // title: 'Track order',
        // url: '/shop/track-order',
        title: <FormattedMessage id="topbar.aboutUs" defaultMessage="About Us" />, url: '/site/about-us'
    },

    {
        title: <FormattedMessage id="topbar.contacts" defaultMessage="Contacts" />, url: '/site/contact-us'
        // title: 'Compare',
        // url: '/shop/compare',
    //     submenu: {
    //         type: 'menu',
    //         menu: [
    //             {
    //                 title: 'Shop Grid',
    //                 url: '/shop/category-grid-3-columns-sidebar',
    //                 submenu: [
    //                     { title: '3 Columns Sidebar', url: '/shop/category-grid-3-columns-sidebar' },
    //                     { title: '4 Columns Full', url: '/shop/category-grid-4-columns-full' },
    //                     { title: '5 Columns Full', url: '/shop/category-grid-5-columns-full' },
    //                 ],
    //             },
    //             { title: 'Shop List', url: '/shop/category-list' },
    //             { title: 'Shop Right Sidebar', url: '/shop/category-right-sidebar' },
    //             {
    //                 title: 'Product',
    //                 url: '/shop/product-standard',
    //                 submenu: [
    //                     { title: 'Product', url: '/shop/product-standard' },
    //                     { title: 'Product Alt', url: '/shop/product-columnar' },
    //                     { title: 'Product Sidebar', url: '/shop/product-sidebar' },
    //                 ],
    //             },
    //             { title: 'Cart', url: '/shop/cart' },
    //             { title: 'Checkout', url: '/shop/checkout' },
    //             { title: 'Order Success', url: '/shop/checkout/success' },
    //             { title: 'Wishlist', url: '/shop/wishlist' },
    //             { title: 'Compare', url: '/shop/compare' },
    //             { title: 'Track Order', url: '/shop/track-order' },
    //         ],
    //     },
     },
    // {
    //     title: 'Blog',
    //     url: '/blog/category-classic',
    //     submenu: {
    //         type: 'menu',
    //         menu: [
    //             { title: 'Blog Classic', url: '/blog/category-classic' },
    //             { title: 'Blog Grid', url: '/blog/category-grid' },
    //             { title: 'Blog List', url: '/blog/category-list' },
    //             { title: 'Blog Left Sidebar', url: '/blog/category-left-sidebar' },
    //             { title: 'Post Page', url: '/blog/post-classic' },
    //             { title: 'Post Without Sidebar', url: '/blog/post-full' },
    //         ],
    //     },
    // },
    // {
    //     title: 'Pages',
    //     url: '/site/about-us',
    //     submenu: {
    //         type: 'menu',
    //         menu: [
    //             { title: 'About Us', url: '/site/about-us' },
    //             { title: 'Contact Us', url: '/site/contact-us' },
    //             { title: 'Contact Us Alt', url: '/site/contact-us-alt' },
    //             { title: '404', url: '/site/not-found' },
    //             { title: 'Terms And Conditions', url: '/site/terms' },
    //             { title: 'FAQ', url: '/site/faq' },
    //             { title: 'Components', url: '/site/components' },
    //             { title: 'Typography', url: '/site/typography' },
    //         ],
    //     },
    // },
    // {
    //     title: 'Buy Theme',
    //     url: 'https://themeforest.net/item/stroyka-tools-store-react-ecommerce-template/23909258',
    //     props: {
    //         external: true,
    //         target: '_blank',
    //     },
    // },
];
